import { Injectable } from "@angular/core";
import { TreasuryBankAccountsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { TreasuryBankAccountsPort } from "../../../app/ports/treasury/bank-accounts.port";
import {
  TreasuryBankAccount,
  TreasuryBankAccountRequest,
  TreasuryBankAccountPage,
  TreasuryBankAccountPageRequest,
} from "../../../domain/models/treasury/bank-account.model";
import {
  mapTreasuryBankAccount,
  mapTreasuryBankAccountPage,
  mapTreasuryBankAccountPageRequest,
  mapTreasuryBankAccountRequest,
} from "../../mappers/treasury/bank-account.mapper";

@Injectable({ providedIn: "root" })
export class TreasuryBankAccountsPortAdapter implements TreasuryBankAccountsPort {
  constructor(private readonly api: TreasuryBankAccountsService) {}

  listPage(request: TreasuryBankAccountPageRequest): Observable<TreasuryBankAccountPage> {
    return this.api
      .listPage(mapTreasuryBankAccountPageRequest(request))
      .pipe(map(({ data }) => mapTreasuryBankAccountPage(data)));
  }

  listBySupplier(id: number): Observable<readonly TreasuryBankAccount[]> {
    return this.api.listBySupplier(id).pipe(map(({ data }) => data.map(mapTreasuryBankAccount)));
  }

  listByCompany(id: number): Observable<readonly TreasuryBankAccount[]> {
    return this.api.listByCompany(id).pipe(map(({ data }) => data.map(mapTreasuryBankAccount)));
  }

  listByOwner(id: number): Observable<readonly TreasuryBankAccount[]> {
    return this.api.listByOwner(id).pipe(map(({ data }) => data.map(mapTreasuryBankAccount)));
  }

  get(id: number): Observable<TreasuryBankAccount> {
    return this.api.get(id).pipe(map(({ data }) => mapTreasuryBankAccount(data)));
  }

  create(request: TreasuryBankAccountRequest): Observable<TreasuryBankAccount> {
    return this.api.create(mapTreasuryBankAccountRequest(request)).pipe(map(({ data }) => mapTreasuryBankAccount(data)));
  }

  update(id: number, request: TreasuryBankAccountRequest): Observable<TreasuryBankAccount> {
    return this.api.update(id, mapTreasuryBankAccountRequest(request)).pipe(map(({ data }) => mapTreasuryBankAccount(data)));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id).pipe(map(() => undefined));
  }
}
